import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import useGenieBrandsOptions from '../../../../hooks/useGenieBrandsOptions';
import WithError from '../../../../components/with-error/WithError';
import CommonDropdown from '../../../../components/common-dropdown/CommonDropdown';

function GenieNameFormInner() {
  const { t } = useTranslation('projects');

  const genieBrandsOptions = useGenieBrandsOptions();
  const isNameSectionLoading = useSelector((state) => state.projects.isNameSectionLoading);

  return (
    <>
      <Field name='brand'>
        {({ input, meta }) => (
          <WithLabel variant={LABEL_STYLES.ALIGNED} label={t('brand')} maxWidth={360} isBold>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonDropdown
                value={input.value}
                options={genieBrandsOptions}
                onSelect={input.onChange}
                name={input.name}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                isError={meta.touched && meta.error}
                isLoading={isNameSectionLoading}
              />
            </WithError>
          </WithLabel>
        )}
      </Field>
    </>
  );
}

export default GenieNameFormInner;
